import { render, staticRenderFns } from "./BetadinePage.vue?vue&type=template&id=588a45ab"
import script from "./BetadinePage.vue?vue&type=script&lang=js"
export * from "./BetadinePage.vue?vue&type=script&lang=js"
import style0 from "./BetadinePage.vue?vue&type=style&index=0&id=588a45ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports